export default __webpack_public_path__ + "static/media/mykulychyn_prapor.cdd15751.png";